import { StorefrontItem } from "@utils";

export const itemToKey = (item: StorefrontItem) => {
    const keyFromId = item.titleID
    const keyFromImage = item.image && item.image.url
    const keyFromLink = item.link && item.link.url
    const keyFromTitle = item.title
    return keyFromId || keyFromImage || keyFromLink || keyFromTitle
}